// extracted by mini-css-extract-plugin
module.exports = {"item":"flowchartItem_item__3oxMh"};